var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTransportSubway({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.4 18 .8 2H8.8l.8-2h4.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8v4H8V8h8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 0c6.627 0 12 5.373 12 12v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V12C0 5.373 5.373 0 12 0ZM8.56 4A2.56 2.56 0 0 0 6 6.56V16c0 .973.695 1.781 1.615 1.96L6 22h12l-1.616-4.04A1.999 1.999 0 0 0 18 16V6.56A2.56 2.56 0 0 0 15.44 4H8.56Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H6l1.6-4h2l-.8 2h6.4l-.8-2h2l1.6 4Z",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTransportSubway);
export default __webpack_public_path__ + "static/media/ic_action_transport_subway.7e9f182c8dcf1208b6116f1ab3b70346.svg";
export { ForwardRef as ReactComponent };